import {HttpHeaders, RequestOptions} from "@web-libs/core/http/api/http.types";

export const withHeaders = (requestOptions:RequestOptions = {}, headers?:HttpHeaders) => {
    if (!headers)
        return requestOptions;
    return {
        ...requestOptions,
        headers: {
            ...requestOptions.headers,
            ...headers
        }
    }
}

export const withTenantId = (requestOptions:RequestOptions = {}, tenantId?:string) => {
    if (!tenantId)
        return requestOptions;
    return {
        ...requestOptions,
        tenantId
    }
}
